import { ButtonRadioGroup } from '@/components/common/Button'
import { useIsNavigating } from '@/components/providers/NavigationProvider'
import { usePage } from '@/components/providers/PageProvider'
import { FILTER_BUDGET_EMPTY_LABEL, FILTER_BUDGET_LABELS } from '@/defs/filters'
import { SCROLL_GALLERY } from '@/defs/scroll'
import { useLinkInternal } from '@/hooks/useLinkInternal'

export const FilterInputBudget = () => {
  const { buildRelative } = useLinkInternal()
  const isNavigating = useIsNavigating()
  const { page } = usePage()

  const route = page?.route
  const budgetOptions = page?.optionsFilters?.budgets

  if (!budgetOptions) return null

  const options = [
    {
      isSelected: !route?.budget,
      label: FILTER_BUDGET_EMPTY_LABEL.label,
      linkInternalProps: {
        href: buildRelative({ budget: undefined }),
        scroll: SCROLL_GALLERY,
      },
      title: FILTER_BUDGET_EMPTY_LABEL.label,
    },
    ...budgetOptions.map(({ budget, count }) => {
      const disabled = count < 1
      const popover = disabled ? <p>Not enough data!</p> : undefined
      const isSelected = budget === route?.budget

      return {
        disabled,
        isSelected,
        label: FILTER_BUDGET_LABELS[budget].label,
        linkInternalProps: {
          href: buildRelative({ budget: !isSelected ? budget : undefined }),
          scroll: SCROLL_GALLERY,
        },
        popover,
        title: FILTER_BUDGET_LABELS[budget].labelLong,
      }
    }),
  ]

  return <ButtonRadioGroup allowSelectedLink options={options} showLoadingMask={isNavigating} />
}
